export const API_URL = process.env.VUE_APP_API_SERVER_URL;
export const RECAPTCHA_KEY = process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY;
export default API_URL;
